import qs from 'qs';
import localStorage from './local-storage';

const location = window.location;
const JSON = window.JSON;

const statsUrl = 'https://atomgit-report-data.atomgit.com/report';
const statsNamePrefix = '_oafs';

// -----------------------------------

const stats = window.oafStats;
const siteId = stats.siteId;
const storageName = `${statsNamePrefix}_${siteId}`;
const storageSourceName = `${statsNamePrefix}_source`;

const OPERATION_PV = 1;
const OPERATION_ACTION = 2;

// URL 来源参数有效期，单位：秒
const URL_SOURCE_EXPIRES = 60 * 60 * 2;

// 页面 PV 统计用的 button id
const DEFAULT_PV_IDENTIFIER = '!';

// 保留多少层来源
const TOTAL_SOURCE = 2;

let platform = '';
let deviceId = '';
let urlParams = {};
let urlSource = '';

const userAgent = window.navigator?.userAgent ?? '';
// const currentUrl = location.href.split('?')[0];
const isAndroid = /android/i.test(userAgent);
const isIos = /iphone|ipad|ipod/i.test(userAgent);

// ---------------------------------------------------------

// 获取 platform 信息
const getPlatform = () => {
  let system = '';

  if (isAndroid) {
    system = 'android';
  }
  else if (isIos) {
    system = 'ios';
  }
  else {
    system = 'pc';
  }

  return system;
};

// 生成唯一 ID
const generateId = (length = 10) => {
  const parts = (+new Date()).toString().split('').reverse();
  let id = '';

  for (let i = 0; i < length; ++i) {
    id += parts[Math.floor(Math.random() * parts.length)];
  }

  return id;
};

const getDeviceId = () => {
  let id = '';

  const data = JSON.parse(localStorage.getItem(storageName)) || {};

  if (data.deviceId) {
    id = data.deviceId;
  }
  else {
    id = generateId();
    data.deviceId = id?.trim?.() ?? id;
    localStorage.setItem(storageName, JSON.stringify(data));
  }

  return id;
};

// 获取 URL 来源参数
const getUrlSource = () => {
  let source = '';
  const data = JSON.parse(localStorage.getItem(storageName)) || {};
  const sourceParam = urlParams.utm_source
    || '';

  const now = new Date().getTime();

  if (sourceParam) {
    source = sourceParam;
    data.urlSource = {
      value: sourceParam,
      time: now,
    };
    localStorage.setItem(storageName, JSON.stringify(data));
  }
  else {
    if (data.urlSource?.value) {
      const time = Number(data.urlSource.time);

      if (!isNaN(time)) {
        if (now - time > URL_SOURCE_EXPIRES * 1000) {
          // 过期了
          data.urlSource = {};
        }
        else {
          source = data.urlSource.value;
        }
      }
      else {
        // time 值非法，认为过期了
        data.urlSource = {};
      }

      localStorage.setItem(storageName, JSON.stringify(data));
    }
  }

  return source;
};

const getPageId = () => stats.default.pageId || document.title;

const getReferrer = () => document.referrer;

const getOperationSource = () => {
  const pageId = getPageId();
  let sourceData = JSON.parse(localStorage.getItem(storageSourceName)) || [];

  // 获取 URL 来源参数
  const sourceParam = urlSource;

  const lastSource = sourceData[sourceData.length - 1];

  if (!lastSource) {
    // 没有任何来源记录
    sourceData.push({
      siteId,
      pageId,
      source: sourceParam,
    });
  }
  else {
    // 有记录，判断是否是当前页记录
    if (lastSource.siteId != siteId || lastSource.pageId != pageId || lastSource.source != sourceParam) {
      // 不是当前页
      sourceData.push({
        siteId,
        pageId,
        source: sourceParam,
      });
    }
  }

  sourceData = sourceData.splice(-TOTAL_SOURCE);

  localStorage.setItem(storageSourceName, JSON.stringify(sourceData));

  // 返回 opsrc 内容
  let index = 1;
  const result = {};

  for (let i = sourceData.length - 1; i >= 0; i--) {
    const data = sourceData[i];

    result[`src${index}`] = {
      w: data.siteId,
      pid: data.pageId,
      s: data.source || undefined,
    };
    index++;
  }

  return JSON.stringify(result);
};

const isEmptyObject = (obj) => {
  for (const prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }

  return true;
};

// 删除对象中的空值
const removeEmptyValueForObject = (obj) => {
  const result = {};

  for (const prop in obj) {
    if (obj[prop] !== undefined && obj[prop] !== null && obj[prop] !== '') {
      result[prop] = obj[prop];
    }
  }

  return result;
};

const send = (params = {}, loadCallback) => {
  const newParams = {
    pid: getPageId(),
    ...params,
    w: siteId,
    p: platform,
    ud: deviceId,
    u: stats.default.userId,
    refer: getReferrer(),
    _: String(+new Date()) + String(Math.floor(Math.random() * 9999)),
  };

  const img = new Image();

  if (typeof loadCallback === 'function') {
    img.addEventListener('error', loadCallback);
  }

  // 开始发送打点请求
  img.src = `${statsUrl}?${qs.stringify(newParams)}`;
};

// ---------------------------------------

// 解析 URL 参数
urlParams = {
  ...qs.parse(location.search?.replace(/^\?/, '')),
  ...qs.parse(location.hash?.replace(/.*\?/, '')),
};
// 获取设备 ID
deviceId = getDeviceId();
// 获取平台信息
platform = getPlatform();
// 获取 URL 来源参数
urlSource = getUrlSource();

const operation = (op, buttonId, params, loadCallback) => {
  if (typeof params === 'function') {
    loadCallback = params;
    params = {};
  }

  const extra = removeEmptyValueForObject({
    s: urlSource,
    ...stats.default.extra,
    ...params,
  });

  if (!buttonId) {
    return false;
  }

  send({
    tn: buttonId,
    t: op,
    e: isEmptyObject(extra) ? undefined : JSON.stringify(extra),
    r: getOperationSource(),
  }, loadCallback);
};

stats.pv = (buttonId = DEFAULT_PV_IDENTIFIER, loadCallback) => {
  if (typeof buttonId === 'function') {
    loadCallback = buttonId;
    buttonId = DEFAULT_PV_IDENTIFIER;
  }

  operation(OPERATION_PV, buttonId, {}, loadCallback);
};

stats.action = (buttonId, params = {}, loadCallback) => {
  operation(OPERATION_ACTION, buttonId, params, loadCallback);
};

// ---------------------------------------

// 初始化
stats.queue.forEach((value) => {
  let item = { ...value };
  const type = item.type;
  const button = item.button;

  item = { ...item.extra };

  delete item.type;
  delete item.button;
  delete item.extra;

  switch (type) {
    case 'pv':
      stats.pv(button || DEFAULT_PV_IDENTIFIER);
      break;

    default:
    case 'action':
      stats.action(button, item);
      break;
  }
});
